import React from 'react';
import { Box, Typography } from '@mui/material';
import ComingSoonImage from '../../assets/ComingSoon.jpg';

interface ComingSoonSectionProps {
  isDark: boolean;
}

const ComingSoonSection: React.FC<ComingSoonSectionProps> = ({ isDark }) => {
  const discordFont = {
    fontFamily: '"Inter", "Segoe UI", "Roboto", sans-serif',
    fontWeight: 800,
    letterSpacing: '-0.02em',
  };

  const goldColor = '#C4B66F';
  const deepGreen = '#051814';

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100vw',
        maxWidth: '100%',
        height: 'auto',
        minHeight: { xs: '400px', md: '600px' },
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* Background Image */}
      <Box
        component="img"
        src={ComingSoonImage}
        alt="Coming Soon"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          filter: 'blur(3px)',
          transform: 'scale(1.02)',
        }}
      />
      
      {/* Content */}
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          textAlign: 'center',
          px: { xs: 3, md: 4 },
          py: { xs: 4, md: 6 },
          borderRadius: { xs: '20px', md: '32px' },
          background: isDark 
            ? 'rgba(255, 255, 255, 0.05)' 
            : 'rgba(255, 255, 255, 0.7)',
          backdropFilter: 'blur(15px)',
          border: isDark 
            ? '1px solid rgba(196, 182, 111, 0.2)' 
            : '1px solid rgba(5, 24, 20, 0.1)',
          boxShadow: isDark 
            ? '0 20px 80px rgba(0,0,0,0.3)' 
            : '0 20px 80px rgba(5, 24, 20, 0.1)',
          maxWidth: { xs: '90%', md: '800px' },
          mx: 'auto',
          my: { xs: 4, md: 6 },
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4.5rem', lg: '5rem' },
            mb: 3,
            color: isDark ? 'white' : deepGreen,
            textShadow: isDark ? '0 4px 20px rgba(0,0,0,0.5)' : 'none',
            ...discordFont,
            textTransform: 'uppercase',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          Coming Soon
        </Typography>
        <Typography
          variant="h6"
          sx={{
            mb: 2,
            color: isDark ? 'rgba(255, 255, 255, 0.9)' : 'rgba(5, 24, 20, 0.8)',
            fontSize: { xs: '1rem', md: '1.25rem' },
            fontWeight: 400,
            lineHeight: 1.6,
          }}
        >
          We're brewing something extraordinary for the remote work community.
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: isDark ? 'rgba(255, 255, 255, 0.7)' : 'rgba(5, 24, 20, 0.7)',
            fontSize: { xs: '0.9rem', md: '1rem' },
            maxWidth: '500px',
            mx: 'auto',
            lineHeight: 1.6,
          }}
        >
          Stay tuned for exciting new features and enhancements that will transform 
          your remote work experience and café connections.
        </Typography>
      </Box>
    </Box>
  );
};

export default ComingSoonSection;